import { CareplanColumns } from '@/models';
import { CareInstitutionService, ErrorService } from '@/services';
import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-task-registration-data',
  templateUrl: './task-registration-data.component.html',
  styleUrls: ['./task-registration-data.component.scss'],
  standalone: false,
})
export class TaskRegistrationDataComponent implements OnInit {
  @Input() data: any;
  @Input('close-button') closeButton: boolean = true;
  @Input() functionType: string;
  @Input() careInstitutionId: string;
  @Input() patientId: string;

  isActive: boolean = true;

  columns: CareplanColumns;

  constructor(
    @Optional() public dialogRef: MatDialogRef<TaskRegistrationDataComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dataDiag: any,
    private careInstitutionService: CareInstitutionService,
    private errorService: ErrorService
  ) {}

  ngOnInit() {
    const source = this.data ?? this.dataDiag;
    if (source) {
      this.data = source;
      const reg = source.dataRegistration ?? {};
      this.isActive = reg.is_active ?? reg.isActive ?? reg.active ?? true;
      this.careInstitutionId = source.careInstitutionId ?? this.careInstitutionId;
      this.functionType = source.functionType ?? this.functionType;
      this.patientId = source.patientId ?? this.patientId;
    }
    if (this.careInstitutionId && this.functionType === 'careplan') {
      this.getCareplanColumnHeaders(this.careInstitutionId);
    }
  }

  getCareplanColumnHeaders(careInstitutionId: string) {
    this.careInstitutionService.getCareInstitutionCareplanColumns(careInstitutionId).subscribe({
      next: (d: CareplanColumns) => {
        this.columns = d;
      },
      error: e => {
        this.errorService.onError(e);
      },
    });
  }
}
